<template>
	<div class="h-full">
		<NuxtLink
			v-if="link"
			:to="link"
			:class="contentStyles"
			:style="{
				backgroundColor: blok.background_color?.color || ''
			}"
		>
			<HeroWithTextContent :blok="blok" :align-button="alignButton" />
		</NuxtLink>
		<div
			v-else
			:class="contentStyles"
			:style="{
				backgroundColor: blok.background_color?.color || ''
			}"
		>
			<HeroWithTextContent :blok="blok" :align-button="alignButton" />
		</div>
	</div>
</template>

<script setup lang="ts">
import type { BlokHeroWithText } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokHeroWithText;
	alignButton?: boolean;
}
const { blok } = defineProps<Props>();
const localePath = useLocalePath();
const { linkPath } = useStoryblokLink();

const link = computed(() => {
	const path = linkPath(blok.call_to_action[0]?.button_link);
	return path ? localePath(path) : null;
});
const contentStyles = computed(
	() =>
		`${blok.isColumnDirection ? "flex flex-col" : "grid md:grid-cols-2"} ${blok.rounded ? `${blok.rounded} overflow-hidden` : ""} content-start w-full h-full ${blok.background_color?.color ? "" : "bg-gray-200"}`
);
</script>
